import declare from "dojo/_base/declare";
import New from "csi/table/New";
import NewFromBOMSKULabelDataSheetsFormMixin from "./NewFromBOMSKULabelDataSheetsFormMixin";

const NewFromBOMSKULabelDataSheets = declare(New, {

	bomType: null,
	bomRevType: null,

	/**
     * @override
     * set NewFromBOMSKULabelDataSheets form controller
     */
	onCreatePopupDefView: function(defView) {
		defView.classController = NewFromBOMSKULabelDataSheetsFormMixin;
		defView.classControllerParams = {
			bomType: this.bomType,
			bomRevType: this.bomRevType,
		};
		this.inherited(arguments);
	},
});

export = NewFromBOMSKULabelDataSheets;